import React, { ReactNode } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const ConfirmModal = ({
  onClose,
  onConfirm,
  title,
  body,
  message,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  disableConfirm = false,
}: {
  onClose: () => void;
  onConfirm: () => void;
  body?: ReactNode | (() => ReactNode);
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  disableConfirm?: boolean;
}) => {
  return (
    <Modal isOpen toggle={onClose} id="confirm-modal" className="modal-lg" centered>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        {message}
        {typeof body === 'function' ? body() : body}
      </ModalBody>
      <ModalFooter>
        <Button variant="tertiary" onClick={onClose}>
          {cancelButtonText}
        </Button>
        {!disableConfirm && (
          <Button color="primary" onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;
